"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _statusMap = _interopRequireDefault(require("../../../../ManageTraffic/constants/statusMap"));

var _utils = require("../../../../../common/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var OutputBlockStatusHeader = function OutputBlockStatusHeader(_ref) {
  var dueDate = _ref.dueDate,
      hoursLeft = _ref.hoursLeft,
      percentageComplete = _ref.percentageComplete,
      status = _ref.status;
  var statusToShow = _statusMap.default[status];

  var _getTimeColor = (0, _utils.getTimeColor)(hoursLeft, status),
      statusColor = _getTimeColor.color,
      textStatus = _getTimeColor.status;

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "output-block__status"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "output-block__status__row"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, _extends({
    heading4: true,
    className: "output-block__title"
  }, textStatus), statusToShow), /*#__PURE__*/_react.default.createElement(_uiKit.Text, _extends({
    heading4: true,
    className: "output-block__status__time-left"
  }, textStatus), dueDate && hoursLeft ? (0, _utils.getDaysAndHoursToDueDate)(hoursLeft) : 'N/A')), dueDate && /*#__PURE__*/_react.default.createElement("div", {
    className: "output-block__progress-bar"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "output-block__progress-bar__fill",
    style: {
      backgroundColor: statusColor,
      width: percentageComplete
    }
  })));
};

var _default = (0, _react.memo)(OutputBlockStatusHeader);

exports.default = _default;